import React from 'react';
import { Link } from 'react-router';
import base from '@util/base';
import moment from 'moment';
import Index from './HocIndex';

const columns = model => {
  return [
    {
      title: '项目名称',
      dataIndex: 'projectName',
      render: (text, record) => {
        return (
          <Link to={`/project/open/${model}/${record.id}`}>
            <span>{text}</span>
          </Link>
        );
      },
    },
    {
      title: '评分',
      dataIndex: 'avg',
    },
    {
      title: '入驻孵化器',
      dataIndex: 'incubator',
      render: () => {
        let text = '';
        base.model.forEach(entry => {
          if (entry.key === model) {
            text = entry.name;
          }
        });
        return <span>{text}</span>;
      },
    },
    {
      title: '团队规模',
      dataIndex: 'teamScale',
    },
    {
      title: '提交人',
      dataIndex: 'createName',
    },
    {
      title: '提交时间',
      dataIndex: 'createTime',
      render: (text, record) => {
        return <span>{moment.unix(text).format('YYYY-MM-DD HH:mm:ss')}</span>;
      },
    },
  ];
};

export default Index({
  columns,
});



// WEBPACK FOOTER //
// ./src/components/project/IncubatorList.js